export const IEmbargo = {
  id: 1,
  store_id: '128',
  apppair_id: 0,
  integration_type: 1,
  integration_data: {},
  partner_id: 1,
  partner_link_id: '',
  scopes: [],
  last_user_id: 1,
  created_at: '2024-02-05T11:39:18.252Z',
  updated_at: '2024-02-05T11:39:18.252Z',
  is_archive: false,
  archived_at: null,
  token: 'U2FsdGVkX7GtqsB2q',
  apppair_node_id: '185CFEA71E0F627361E313BB7A4BD17',
}
